import {
  InsightsOperation,
} from '@unu/ui-enums';

import {
  sendEvent,
} from './insights';

import {
  parseTagArgs,
} from './utility';

export const traceInformation = (...args) => sendEvent({
  operation: InsightsOperation.Information,
  args,
});

export const traceWarning = (...args) => sendEvent({
  operation: InsightsOperation.Warning,
  args,
});

export const traceError = (...args) => sendEvent({
  operation: InsightsOperation.Error,
  args,
});

export const tag = (...args) => sendEvent({
  operation: InsightsOperation.Tag,
  args: parseTagArgs(args),
});
